/** Resolve OpenAPI Header Reference Objects, separately from JSON Schema $ref semantics. */
export function resolveHeaderObject(input, lookup, legacy) {
    const chain = new Set();
    function resolve(value) {
        if (value === null || typeof value !== 'object' || Array.isArray(value))
            throw new Error('Header Object reference could not resolve to an object');
        const header = value;
        if (!Object.hasOwn(header, '$ref'))
            return header;
        if (typeof header.$ref !== 'string' ||
            chain.has(header.$ref) ||
            chain.size >= 64)
            throw new Error('Circular, invalid or excessive Header Object reference chain');
        chain.add(header.$ref);
        const target = resolve(lookup(header.$ref));
        return legacy
            ? target
            : {
                ...target,
                ...(typeof header.description === 'string'
                    ? { description: header.description }
                    : {}),
            };
    }
    return resolve(input);
}
//# sourceMappingURL=headers.js.map